import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-artisanal-beige overflow-hidden min-h-[90vh] flex items-center" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 w-full" data-id="element-113">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left z-10" data-id="element-115">
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-artisanal-brown font-bold leading-tight mb-6" data-id="element-116">
              Velas y Jabones Artesanales: <br data-id="element-117" />
              <span className="text-artisanal-terracotta italic font-normal" data-id="element-118">
                El arte de crear con las manos
              </span>
            </h1>
            <p className="font-sans text-lg sm:text-xl text-artisanal-brown/80 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-119">
              Aprende a crear productos hermosos, naturales y únicos desde la
              comodidad de tu hogar. Ya sea para regalar, emprender o
              simplemente disfrutar de un momento creativo y relajante.
            </p>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-artisanal-terracotta text-white font-sans font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:bg-artisanal-terracotta/90 transition-colors" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-120">
              Quiero empezar ahora
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative h-[400px] sm:h-[500px] lg:h-[600px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/d8b8v6tpQ94XTxUzLiF3pv/heylloyd-image-1777154152960.png" alt="Mujer creando jabones artesanales" className="absolute inset-0 w-full h-full object-cover" data-id="element-122" />
            <div className="absolute inset-0 bg-gradient-to-t from-artisanal-brown/30 to-transparent" data-id="element-123"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}